export default __webpack_public_path__ + "static/knightHacksLogoGold-94df7bdce2a0594a5551f9659074a00c.svg";